/* eslint-disable no-shadow */
import { withStyles } from "@material-ui/core";
import React, { useState } from "react";
import styles from "./styles";
import { PROJECT_IMAGE_BASE_URL } from "../../constants/ui";
import Carousel, { Modal, ModalGateway } from "react-images";

import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';

function ProjectItem(props) {
  const { item, classes } = props;
  const photos = JSON.parse(item.multi_picture);

  const mapPhotos = photos.map(item => ({
    src: `${PROJECT_IMAGE_BASE_URL}/${item}`
  }));

  const [modalIsOpen, setmodalIsOpen] = useState(false);

  const openLightbox = () => {
    setmodalIsOpen(true)
  }

  const closeLightbox = () => {
    setmodalIsOpen(false)
  }

  return (
    <div className={classes.box}>
      <div className={`${classes.boxImg} boxImg`}>
        <a
          target="_blank"
          rel="noopener noreferrer"
          title={item.name}
          href={item.links}
        >
          <img
            className={classes.img}
            src={`${PROJECT_IMAGE_BASE_URL}/big/${item.picture}`}
            alt={item.name}
          />
        </a>
      </div>
      <div className={classes.boxDetail}>
        <div>
          <h6>
            <a
              target="_blank"
              rel="noopener noreferrer"
              title={item.name}
              href={item.links}
            >
              {item.name}
            </a>
          </h6>
          <h5>
            <a
              target="_blank"
              rel="noopener noreferrer"
              title={item.links}
              href={item.links}
            >
              {item.links}
            </a>
          </h5>
        </div>
        <button
          onClick={openLightbox}
        >
          <PhotoLibraryIcon style={{ fontSize: 20 }} />
        </button>

        <ModalGateway>
          {modalIsOpen && mapPhotos.length > 0 ? (
            <Modal onClose={closeLightbox} className={classes.modelPreview}>
              <Carousel
                currentIndex={0}
                views={mapPhotos.map(x => ({
                  ...x,
                  srcset: x.srcSet,
                  caption: x.title,
                }))}
              />
            </Modal>
          ) : null}
        </ModalGateway>

      </div>
    </div>
  );
}

export default withStyles(styles)(ProjectItem);
